import { Component, OnInit, ViewChild } from '@angular/core';
import { LedgerEntry, TallyTransactionsListModel, ViewTallyTransactionsModel } from '../../models/view-tally-transactions-model';
import { ViewTallyTransactionService } from '../../services/view-tally-transaction-service';
import { UtilityService } from '../../services/utility-service';
import { MatTableDataSource } from '@angular/material/table';
import { PurposeLedgerMapHeader } from '../../models/purpose-leger-mapmaster-mode';
import { HttpResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MatTabGroup } from '@angular/material/tabs';
import { MatPaginator } from '@angular/material/paginator';
import { ColourCodesTheme } from '../../models/common-colours';

@Component({
  selector: 'app-view-tally-transactions',
  templateUrl: './view-tally-transactions.component.html',
  styleUrls: ['./view-tally-transactions.component.css']
})
export class ViewTallyTransactionsComponent implements OnInit {

  @ViewChild('paginatorJSYM', { static: true }) 
  l_paginatorJSYM: MatPaginator;
  
  @ViewChild('paginatorTAAM', { static: true }) 
  l_paginatorTAAM: MatPaginator;

  @ViewChild('tallyTabsGroup')
  l_tallyTabsGroup!: MatTabGroup;
  //this.lFN_SwitchTabs(this.l_tallyTabsGroup, 1);

  public l_formData: ViewTallyTransactionsModel = new ViewTallyTransactionsModel();
  public l_tallyTransactionList: TallyTransactionsListModel[] = [];
  public l_showLedgerEntryModal: boolean = false;
  public l_showExportModal: boolean = false;
  public l_showDeleteTallyEntryModal: boolean = false;
  public l_showDownloadXMlButton: boolean = false;
  public l_showSyncTxnButton: boolean = false;
  public l_ledgerEntriesObject: any = {};
  public l_tallyObject: TallyTransactionsListModel = null;
  
  public dataSourceJSYM = new MatTableDataSource<TallyTransactionsListModel>();
  public displayedColumnsJSYM: string[] = ['txnDate', 'receiptNumber', 'narration', 'purpose', 'amount', 'status', 'ledgerEntries'];

  public dataSourceTAAM = new MatTableDataSource<TallyTransactionsListModel>();
  public displayedColumnsTAAM: string[] = ['txnDate', 'receiptNumber', 'narration', 'purpose', 'amount', 'status', 'ledgerEntries', 'actions'];
  
  public dataSourceLedgerEntry = new MatTableDataSource<LedgerEntry>();
  public displayedColumnsLedgerEntry: string[] = ['name', 'entryType', 'amount'];

  public ledgerwiseHeaders: any = 'Ledger Head Name, Transaction Count, Total Amount';
  public purposewiseHeaders: any = 'Purpose Name, Transaction Count, Total Amount';

  constructor(
    private l_ViewTallyTransactionService: ViewTallyTransactionService,
    private l_UtilityService: UtilityService,
    private l_datePipe: DatePipe
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.dataSourceJSYM.paginator = this.l_paginatorJSYM;
    this.dataSourceTAAM.paginator = this.l_paginatorTAAM;
  }

  async lFN_ViewTallyTransactions() {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    let l_listResponse = this.l_ViewTallyTransactionService.lFN_GetViewTallyTransactionsList(l_fromDateStr, l_toDateStr);
    l_listResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          this.l_UtilityService.lFN_HideLoader();

          let l_list_TAAM: TallyTransactionsListModel[] = [];
          let l_list_JSYM: TallyTransactionsListModel[] = [];
          for await (const element of JSON.parse(data.body).data) {
            let l_object = new TallyTransactionsListModel(element);
            console.log('l_object?.source ===> ', l_object?.source);
            if(l_object?.source === 'TAAM') {
              l_list_TAAM.push(l_object);
            } else {
              l_list_JSYM.push(l_object);
            }
          }
          this.dataSourceJSYM.data = l_list_JSYM;
          this.dataSourceTAAM.data = l_list_TAAM;
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to pull datalist', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_ViewLedgerEntries(l_element: any) {
    console.log('l_element === ', l_element);
    console.log('l_element.ledgerEntries === ', l_element.ledgerEntries);
    this.l_ledgerEntriesObject = l_element.ledgerEntries;
    this.dataSourceLedgerEntry.data = l_element.ledgerEntries;
    this.l_showLedgerEntryModal = true;
  }

  async lFN_DeleteTallyEntries(l_tallyElement: any, l_action: string) {
    console.log('l_tallyElement === ', l_tallyElement);
    
    if(l_action === 'HOLD_OBJECT_DATA') {
      this.l_tallyObject = l_tallyElement;
      //_display_confirmation
      this.l_showDeleteTallyEntryModal = true;
    } else if(l_action === 'DELETE_OBJECT') {
      //_delete_entry
      this.l_showDeleteTallyEntryModal = false;
      let l_removeTallyTransactionResponse = this.l_ViewTallyTransactionService.lFN_DeleteTallyTransaction(this.l_tallyObject.tallyId);
      l_removeTallyTransactionResponse.subscribe({
        next: async (data) => {
          if (data.status == 200) {
            this.l_UtilityService.lFN_HideLoader();
            this.l_tallyObject = null;
            console.log('l_responseData ===> ', data.body);
            //this.l_UtilityService.lFN_SuccessToaster(data.body, 'Deleted Successfully');
            this.l_UtilityService.lFN_DisplayModal({
              l_title: 'Deleted Successfully',
              l_message: data.body,
              l_colour: new ColourCodesTheme().l_Green
            });
            await this.lFN_ViewTallyTransactions();
          }
        },
        error: (l_error) => {
          console.error('error_response: ', l_error);
          //this.l_UtilityService.lFN_ErrorToaster(l_error.error, 'Unable to delete Tally transaction');
          this.l_UtilityService.lFN_DisplayModal({
            l_title: 'Unable to delete Tally transaction',
            l_message: l_error.error,
            l_colour: new ColourCodesTheme().l_Red
          });
          this.l_UtilityService.lFN_HideLoader();
          this.l_tallyObject = null;
        },
        complete: () => {
          console.log('Request completed');
          this.l_UtilityService.lFN_HideLoader();
        }
      });
    }
  }

  async lFN_CloseModals() {
    this.l_showLedgerEntryModal = false;
    this.l_showExportModal = false;
    this.l_showDeleteTallyEntryModal = false;
  }

  async lFN_Export() {
    this.l_showExportModal = true;
  }

  async lFN_DownloadReport(l_reportType: string) {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    let l_reportData = this.l_ViewTallyTransactionService.lFN_GetTallyReportData(l_fromDateStr, l_toDateStr, l_reportType);
    l_reportData.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_HideLoader();
          let l_reportData = JSON.parse(data.body).data;
          //_download_tally_reports_types
          if(l_reportType === 'ledgerwise') {
            await this.lFN_DownloadTallyCSV(l_reportData, this.ledgerwiseHeaders, 'Ledgerwise_Report', l_fromDateStr, l_toDateStr);
          } else if(l_reportType === 'purposewise') {
            await this.lFN_DownloadTallyCSV(l_reportData, this.purposewiseHeaders, 'Purposewise_Report', l_fromDateStr, l_toDateStr);
          } else if(l_reportType === 'detailedLedgerwise') {
            await this.lFN_DownloadDetailedCSV(l_reportData);
          }
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to pull data for report type and range selected', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_DownloadTallyCSV(responseData: unknown, headersCSV: string, reportType: string, fromDate: string, toDate: string) {
    if (typeof responseData !== 'object' || responseData === null) {
        console.error("Invalid responseData");
        return;
    }

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += `${reportType} ${fromDate} to ${toDate}\n\n`;
    csvContent += headersCSV + "\n";

    Object.entries(responseData as Record<string, { countTransactions?: number; amount?: number; }>).forEach(([mainKey, subData]) => {
        const countTransactions = (subData as any).countTransactions ?? '';
        const amount = (subData as any).amount ?? '';
        csvContent += `${mainKey},${countTransactions},${amount}\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().replace(/[-T:.Z]/g, "");
    link.setAttribute("download", `${reportType}_${formattedDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async lFN_DownloadDetailedCSV(responseData: unknown) {
    const data = responseData as { naration: string; [key: string]: any }[];
    let csvContent = "data:text/csv;charset=utf-8,";
    if (data.length === 0) {
      console.error("No data available to download.");
      return;
    }

    const headers = Object.keys(data[0]).map(header => 
      header.charAt(0).toUpperCase() + header.slice(1)
    );
    csvContent += headers.join(",") + "\n";

    for (const item of data) {
        item.naration = item.naration.replace(/,/g, "|");
        //_special_character_checks
        if (item.naration.includes("#")) {
            item.naration = item.naration.replace("#", "");
        }
        csvContent += Object.values(item).join(",") + "\n";
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().replace(/[-T:.Z]/g, "");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Detailed_ledgerwise_report_${formattedDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async lFN_CheckDates() {
    if(this.l_formData.fromDate === undefined || this.l_formData.toDate === undefined || this.l_formData.fromDate === null || this.l_formData.toDate === null) {
      return false;
    } else {
      return true;
    }
  }

  async lFN_VerifyTransactions() {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    let l_verifyResponse = this.l_ViewTallyTransactionService.lFN_VerifyTransactionsDone(l_fromDateStr, l_toDateStr);
    l_verifyResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_HideLoader();
          let l_verifyResponseObject = JSON.parse(data.body).data;
          console.log('l_verifyResponseObject === ', l_verifyResponseObject);
          
          if(l_verifyResponseObject.totalTransactions == l_verifyResponseObject.totalTallyTransactions && l_verifyResponseObject.totalAmount == l_verifyResponseObject.totalTallyTransactionsAmt) {
            this.l_UtilityService.lFN_SuccessToaster('Please proceed to download XML transactions file', 'Verified Successfully');
            this.l_UtilityService.lFN_DisplayModal({
              l_title: 'Transactions Verified Successfully',
              l_message: await this.lFN_createVerifiedResponseToDisplay(l_verifyResponseObject) + 'Proceed to generate XML file for tally import',
              l_colour: new ColourCodesTheme().l_Green
            });
            this.l_showDownloadXMlButton = true;
            this.l_showSyncTxnButton = false;
          } else {
            this.l_UtilityService.lFN_WarningToaster('Transactions count and amount have difference', 'Please Sync Transactions');
            this.l_UtilityService.lFN_DisplayModal({
              l_title: 'Please Sync Transactions',
              l_message: await this.lFN_createVerifiedResponseToDisplay(l_verifyResponseObject) + 'Transactions count and amount have difference',
              l_colour: new ColourCodesTheme().l_WarnYellow
            });
            this.l_showSyncTxnButton = true;
            this.l_showDownloadXMlButton = false;
          }
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to verify transactions', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_createVerifiedResponseToDisplay(l_verifyResponseObject: any) {
    console.log('l_verifyResponseObject ===> ', l_verifyResponseObject);

    const totalTransactions = l_verifyResponseObject.totalTransactions || 0;
    const totalTallyTransactions = l_verifyResponseObject.totalTallyTransactions || 0;
    const totalAmount = l_verifyResponseObject.totalAmount || 0;
    const totalTallyTransactionsAmt = l_verifyResponseObject.totalTallyTransactionsAmt || 0;
  
    const htmlResponse = `
      <div class="verification-response">
        <h3><b>Verification Summary</b></h3>
        <ul>
          <li><strong>Total Transactions:</strong> ${totalTransactions}</li>
          <li><strong>Total Tally Transactions:</strong> ${totalTallyTransactions}</li>
          <li><strong>Total Amount:</strong> ₹ ${totalAmount}</li>
          <li><strong>Total Tally Transactions Amount:</strong> ₹ ${totalTallyTransactionsAmt}</li>
        </ul>
      </div>
    `;
    return htmlResponse;
  }
  

  async lFN_SyncTallyTransactions() {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    console.log('l_fromDateStr ===> ', l_fromDateStr);
    console.log('l_toDateStr ===> ', l_toDateStr);

    let l_syncResponse = this.l_ViewTallyTransactionService.lFN_SyncTallyTransactions(l_fromDateStr, l_toDateStr);
    l_syncResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_HideLoader();
          let l_syncResponseObject = JSON.parse(data.body).data;
          console.log('l_syncResponseObject === ', l_syncResponseObject);
          this.l_UtilityService.lFN_SuccessToaster('Please proceed to download XML transactions file', 'Transactions synced');
          await this.lFN_DownloadTallyCSV(l_syncResponseObject, this.ledgerwiseHeaders, 'Ledgerwise_Report', l_fromDateStr, l_toDateStr);
          this.l_showSyncTxnButton = false;
          await this.lFN_ViewTallyTransactions();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to Sync Online Transactions', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_SyncAccountsReceipts() {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    console.log('l_fromDateStr ===> ', l_fromDateStr);
    console.log('l_toDateStr ===> ', l_toDateStr);

    let l_syncReceiptsResponse = this.l_ViewTallyTransactionService.lFN_SyncTallyAccountsReceipts(l_fromDateStr, l_toDateStr);
    l_syncReceiptsResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_HideLoader();
          let l_syncReceiptsResponseObject = JSON.parse(data.body);
          console.log('l_syncReceiptsResponseObject === ', l_syncReceiptsResponseObject);
          //this.l_UtilityService.lFN_SuccessToaster(l_syncReceiptsResponseObject.length + ' Transactions Synced successfully to Tally Store', 'Sync Success');
          this.l_UtilityService.lFN_DisplayModal({
            l_title: 'Sync Receipts Successfully',
            l_message: l_syncReceiptsResponseObject.length + ' Transactions Synced successfully to Tally Store',
            l_colour: new ColourCodesTheme().l_Green
          });
          await this.lFN_ViewTallyTransactions();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        //this.l_UtilityService.lFN_ErrorToaster(l_error.error, 'Unable to Sync Receipts');
        this.l_UtilityService.lFN_DisplayModal({
          l_title: 'Unable to Sync Receipts',
          l_message: l_error.error,
          l_colour: new ColourCodesTheme().l_Red
        });
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_CheckUploadDownloadStatus() {
    if(await this.lFN_CheckDates() === false) {
      this.l_UtilityService.lFN_WarningToaster('Please select from date and to date to proceed', 'Improper Date Range');
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    let l_statusResponse = this.l_ViewTallyTransactionService.lFN_CheckUploadDownloadStatus(l_fromDateStr, l_toDateStr);
    l_statusResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          await this.lFN_DownloadTallyXML();
          setTimeout(async() => {
            await this.lFN_ViewTallyTransactions();
            this.l_UtilityService.lFN_HideLoader();
         }, 5000);
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to check upload download status', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_DownloadTallyXML() {
    
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    try {
      let l_xmlResponse = this.l_ViewTallyTransactionService.lFN_DownloadTallyFileXML(l_fromDateStr, l_toDateStr);
      l_xmlResponse.subscribe({
        next: (response: HttpResponse<Blob>) => {
          const blob = response.body;
          const url = window.URL.createObjectURL(blob);
  
          const a = document.createElement('a');
          a.href = url;
          a.download = 'tally_data.xml'; // You can modify the file name as needed
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: () => {
          this.l_UtilityService.lFN_ErrorToaster('Error while Downloading Tally XML file', 'Download Failed');
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        }
      });
    } catch (error) {
      this.l_UtilityService.lFN_ErrorToaster('Error downloading file', 'Download Failed');
      this.l_UtilityService.lFN_HideLoader();
    }
  }

  async lFN_SwitchTabs(l_tallyTabsGroup: MatTabGroup, l_tabIndex: number) {
    l_tallyTabsGroup.selectedIndex = l_tabIndex;
  }

}
